<style scoped>
.form-select {
  padding-top: 5px;
  padding-bottom: 5px;
}

.form-group:not([class*=' col-']) {
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.form-group-custom {
  width: 100%;
  display: flex !important;
  vertical-align: top;
  margin-bottom: 1rem;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-row>
        <b-col>
          <h3>Daily Drilling</h3>
          <p>
            Input your daily drilling report to
            <i>{{ selectedWellName }}</i> well.
          </p>
        </b-col>
        <b-col style="text-align: end">
          <a href="#">
            <b-badge variant="dark" @click="showWellSelection">{{
              optionChangeWell
            }}</b-badge>
          </a>
        </b-col>
      </b-row>
      <div v-if="showOptionChangeWell">
        <b-row class="form-select">
          <b-col cols="1">
            <span class="vertical-center">Field:</span>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="selectedField"
              :options="comboFieldOption"
              @change="fieldChangedEvent"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="form-select">
          <b-col cols="1">
            <span class="vertical-center">Pad:</span>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="selectedPad"
              :options="comboPadOption"
              @change="padChangedEvent"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="form-select" style="padding-bottom: 20px">
          <b-col cols="1">
            <span class="vertical-center">Well:</span>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="selectedWell"
              :options="comboWellOption"
              @change="wellChangedEvent"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
      <hr />
      <h4>Managed Report</h4>

      <b-card style="border: #cccccc solid 0.5px; border-radius: 5px">
        <b-row>
          <b-col>
            <h4>Report List</h4>
            <p style="font-size: 12px; margin-bottom: 0.4rem">
              <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table
              row for more option.
            </p>
          </b-col>
          <b-col style="text-align: end">
            <b-button-group>
              <DxButton
                id="previewButton"
                icon="doc"
                hint="Preview"
                :height="40"
                @click="previewReport" />
              <DxButton
                id="refreshButton"
                icon="revert"
                hint="Refresh"
                :height="40"
                @click="refreshTable" />
            </b-button-group>
          </b-col>
        </b-row>
        <DxDataGrid
          id="daily-report-grid"
          ref="dailyReportGrid"
            :data-source="dailyReportDataSource"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="false"
            :column-auto-width="false"
            date-serialization-format="yyyy-MM-dd"
            :height="350"
            :remote-operations="true"
            @selection-changed="onSelectionChanged"
            @row-inserting="rowInserting"
            @row-updating="rowUpdating"
            @row-inserted="rowInserted"
            @row-updated="rowUpdated"
            @row-removed="rowRemoved"
            @editing-start="editingStart"
          >
            <DxScrolling mode="standard" />
            <DxSorting mode="single" />
            <DxSelection mode="single"/>
            <DxEditing
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
              :use-icons="true"
              mode="form"
            />
            <DxColumn
              type="buttons"
              width="5%"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." :calculate-cell-value="setReportNo"  width="5%" >
              <DxFormItem :visible="false"/>
            </DxColumn>             
            <DxColumn data-type="date" data-field="dateReport" caption="Report Date" width="8%" />
            <DxColumn data-type="datetime" data-field="createdAt" caption="Submit Time" read-only="true" width="12%">
              <DxFormItem :visible="false"/>
            </DxColumn>
            <DxColumn data-field="wellboreName" caption="Wellbore Name" width="15%"/>
            <DxColumn data-field="wellboreType" caption="Wellbore Type" width="8%">
              <DxLookup
                :data-source="optionWellboreType"
                value-expr="value"
                display-expr="text"
              />
            </DxColumn>
            <DxColumn data-field="rigOps" caption="Rig Ops" width="5%"/>
            <DxColumn data-type="number" data-field="rkbHeight" caption="RKB Height" width="8%"> 
              <DxFormat type="fixedPoint" :precision="2" />
            </DxColumn>
            <DxColumn data-type="number" data-field="approvedStatus" caption="Report Status" :allow-sorting="false" :calculate-display-value="getStatusText" read-only="true">
              <DxFormItem :visible="false"/>
            </DxColumn>
            <DxColumn data-field="description" caption="Brief Summary" :allow-sorting="false">
              <DxFormItem :col-span="2" :editor-options="{  height: 50 }" editor-type="dxTextArea" />
            </DxColumn>
        </DxDataGrid>

        <div v-if="selectedRow.length > 0">
          <hr />
          <b-row>
            <b-col>
              <span>
                <h4
                  >Selected Report No. {{ selectedReportNo }}
                  {{ selectedRow.length > 0 ? selectedRow[0].reportNo : '' }}</h4
                >Wellbore/Rig Ops :
                <b>{{
                  selectedRow.length > 0 ? selectedRow[0].wellboreName : ''
                }}</b>
                /
                <b>{{ selectedRow.length > 0 ? selectedRow[0].rigOps : '' }}</b>
                <br />Report Date :
                <b>{{
                  selectedRow.length > 0
                    ? moment(selectedRow[0].dateReport).format('DD MMM YYYY')
                    : ''
                }}</b>
              </span>
            </b-col>
            <b-col style="text-align: end">
              <span v-if="confirmSubmit">
                Are you sure you want to submit this report?
                <b-button-group>
                  <b-button
                    variant="success"
                    size="sm"
                    @click="submitReportAsWaitingApproval"
                    >Yes</b-button
                  >
                  <b-button variant="danger" size="sm" @click="cancelSubmit"
                    >No</b-button
                  >
                </b-button-group>
              </span>
              <b-button
                v-if="totalRows > 0 && !confirmSubmit && editingCheck"
                variant="success"
                size="md"
                @click="doConfirm"
                >Submit Report</b-button
              >
            </b-col>
          </b-row>
          <hr />
          <b-tabs
            small
            class="tabs-form"
            active-nav-item-class="font-weight-bold text-success"
            @activate-tab="tabChanged"
          >
            <b-tab ref="tabGeneral" title="General"> <!-- no lazy option so all components inside don't get destroyed -->
              <General
                :submit-id="submitId"
                :last-submit-id="lastSubmitId"
                :well-id="selectedWell"
                :daily-report-date="selectedReportDate"
                :editable="editingCheck"
              />
            </b-tab>
            <b-tab ref="tabOpsSummary" title="Ops. Summary" lazy>
              <OperationSummary
                :submit-id="submitId"
                :editable="editingCheck"
                :well-id="selectedWell"
                :report-date="selectedReportDate"
              />
            </b-tab>
            <b-tab ref="tabBit" title="Bit" lazy>
              <Bit :submit-id="submitId"
                :editable="editingCheck"
                :well-id="selectedWell"
              />
            </b-tab>
            <b-tab ref="tabBha" title="BHA" lazy>
              <Bha 
                :submit-id="submitId" 
                :last-submit-id="lastSubmitId"
                :editable="editingCheck"
                :well-id="selectedWell"
                :report-map="masterReportMap"
              />
            </b-tab>
            <b-tab ref="tabCost" title="Field Cost" lazy>
              <Cost
                :submit-id="submitId"
                :editable="editingCheck"
                :field-id="selectedField"
                :well-id="selectedWell"
                :last-submit-id="lastSubmitId"
              />
            </b-tab>
            <b-tab ref="tabMaterialUsage" title="Material Usage" lazy>
              <MaterialUsage 
                :submit-id="submitId" 
                :last-submit-id="lastSubmitId" 
                :editable="editingCheck" />
            </b-tab>
            <b-tab ref="tabMud" title="Mud" lazy>
              <Mud 
                :submit-id="submitId" 
                :last-submit-id="lastSubmitId" 
                :editable="editingCheck" />
            </b-tab>
            <b-tab ref="tabSurvey" title="Survey" lazy>
              <Survey 
                :submit-id="submitId"
                :well-id="selectedWell"
                :report-map="masterReportMap" 
                :editable="editingCheck" />
            </b-tab>
            <b-tab ref="tabHSE" title="HSE" lazy>
              <Hse 
                :submit-id="submitId" 
                :last-submit-id="lastSubmitId" 
                :editable="editingCheck" />
            </b-tab>
            <b-tab ref="tabDrillingParameter" title="Drilling Parameters" lazy>
              <DrillingParameter
                :submit-id="submitId"
                :well-id="selectedWell"
                :report-map="masterReportMap"
                :editable="editingCheck"
                />
            </b-tab>
            <b-tab ref="tabDrilledSection" title="Drilled Section" lazy>
              <DrilledSection
                :submit-id="submitId" 
                :editable="editingCheck"
                :well-id="selectedWell"
                :report-map="masterReportMap"
                />
            </b-tab>
          </b-tabs>
        </div>
      </b-card>
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import 'vue-form-generator/dist/vfg.css'
import { fieldMethods, authComputed, formMethods } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxEditing,
  DxLookup,
  DxFormItem,
  DxSelection,
  DxSorting,
  DxButton as GridButton,
  DxFormat
} from 'devextreme-vue/data-grid'
import 'devextreme-vue/text-area'
import DxButton from 'devextreme-vue/button'
import notify from "devextreme/ui/notify"
import General from '@components/form/daily-drilling-report/general'
import Survey from '@components/form/daily-drilling-report/survey'
import Mud from '@components/form/daily-drilling-report/mud'
import Cost from '@components/form/daily-drilling-report/cost'
import OperationSummary from '@components/form/daily-drilling-report/opsum'
import DrillingParameter from '@components/form/daily-drilling-report/drilling-parameters'
import Bit from '@components/form/daily-drilling-report/bit'
import Bha from '@components/form/daily-drilling-report/bha'
import Hse from '@components/form/daily-drilling-report/hse'
import MaterialUsage from '@components/form/daily-drilling-report/material-usage'
import DrilledSection from '@/src/components/form/daily-drilling-report/drilled-section.vue'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'
import DataSource from 'devextreme/data/data_source'
import { confirm } from 'devextreme/ui/dialog'

const isNotEmpty = (value) => value !== undefined && value !== null && value !== ''

export default {
  components: {
    Layout,
    PageHeader,
    General,
    Survey,
    Mud,
    Cost,
    OperationSummary,
    DrillingParameter,
    Bit,
    Bha,
    Hse,
    MaterialUsage,
    DrilledSection,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
    DxFormItem,
    DxScrolling,
    DxSelection,
    DxSorting, 
    DxFormat,
    DxButton,
    GridButton
  },
  data() {
    return {
      showOptionChangeWell: false,
      confirmSubmit: false,
      comboFieldOption: [],
      comboPadOption: [],
      comboWellOption: [],
      selectedField: null,
      selectedPad: null,
      selectedWell: null,
      selectedWellName: null,
      selectedReportDate: null,
      optionChangeWell: 'CHANGE WELL',
      selectedRow: [],
      selectedReportNo: 0,
      perPage: 10,
      currentPage: 1,
      reportData: [],
      masterReportMap: [],
      dailyReportDataStore: null,
      dailyReportDataSource: null,
      wellboreList: [],
      rigOpsList: [],
      formId: 0, // casing form id
      form: {},
      unitStandardId: null,
      selectedAction: '',
      submitId: undefined,
      lastSubmitId: 0,
      optionWellboreType: [
        { text: "Original Hole", value: "Original Hole" },
        { text: "Sidetrack 1", value: "Sidetrack 1"},
        { text: "Sidetrack 2", value: "Sidetrack 2"},
      ],
      items: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Form',
          to: { name: 'form' },
        },
        {
          text: 'Daily Drilling',
          active: true,
        },
      ],
      title: this.$store.state.auth.currentWell.well_name,
      page: {
        title: 'Drilling Activity',
        meta: [{ name: 'description', content: appConfig.description }],
      },
    }
  },
  computed: {
    ...authComputed,
    totalRows() {
      if (this.reportData) return this.reportData.length
      else return 0
    },
    editingCheck() {
      return (this.selectedRow.length > 0) && (this.selectedRow[0].approvedStatus === 1)
    }
  },
  watch: {
    selectedWell: function (val) {
      this.refreshTable()
    },
    selectedRow: function (val, oldVal) {},
  },
  created: function () {
    this.retrieveComboOptionField()
    this.selectedField = this.currentWell.pad.fieldId
    this.retrieveComboOptionPad(this.selectedField)
    this.selectedPad = this.currentWell.padId
    this.retrieveComboOptionWell(this.selectedPad)
    this.selectedWell = this.currentWell.wellId
    this.selectedWellName = this.currentWell.wellName
    this.getReportMap()
    this.unitStandardId = this.currentWell.pad.field.unitStandardId
    this.retrieveWellboreList()
    this.retrieveRigOpsList()

    console.log('AUTH', this.currentUser)
  },
  methods: {
    ...fieldMethods,
    ...formMethods,
    init() {
      this.dailyReportDataStore = new CustomStore({
        key: 'submitId',
        load: (loadOptions) => {
            let params = {}
            let options = [ 'requireTotalCount',  'sort', 'skip', 'take', ]
            options.forEach(function(i) {
              if(i in loadOptions && isNotEmpty(loadOptions[i])) {
                if (i === "sort") {
                  params["sortField"] = loadOptions[i][0].selector
                  params["sortOrder"] = loadOptions[i][0].desc ? 'desc' : 'asc'
                }
                else 
                  params[i] = loadOptions[i]              }
            });
            params.wellId = this.selectedWell
          const url = mapApiUrl('/api/form/master/list-complete')
          /* return axios.get(url, {params: params})
               .then((response) => response.data) */
          return axios.get(url, {params: params})
                      .then(response => {
                        if (response.data.data === undefined) return {data:[], totalCount: 0}
                        if (response.data.data.length === 0) return {data:[], totalCount: 0}
                        let reportData = Array.from(response.data.data)
                        
                        // sort data by report date descendingly
                        reportData.sort((a,b) => { return b.dateReport-a.dateReport}) // Date.parse(a.dateReport) - Date.parse(b.dateReport) })
                        /* this.masterReportMap = []
                        
                          reportData.forEach((item, index) => {
                            item.index = reportData.length-index
                            item.createdAt=item.submittedTime.substr(0,19)
                            this.masterReportMap.push({index: item.index, submitId: item.submitId})
                          }) */
                          // last report is at index 1, when it to be used for carry over data
                          if (reportData.length > 1)
                            this.lastSubmitId = reportData.at(1).submitId                        
                          else this.lastSubmitId = 0
                        return {data: reportData, totalCount: response.data.totalCount}
                  }) 
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.wellId = this.selectedWell
          values.orgId = this.currentUser.orgId
          values.unitStandardId = this.currentUser.unitStandard
          delete values.index
          delete values.createdAt
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/add')
          return axios.post(url, qs.stringify(values)).then(response => {
            this.lastSubmitId = this.masterReportMap.at(-1)[1]
            this.submitId = response.data.submitId
            this.masterReportMap.push({index: this.masterReportMap.length, submitId: this.submitId})
            this.initExtraReports()
            return response.data
          }) 
        },
        update: (key, values) => {
          values.submitId = key
          const url = mapApiUrl('/api/form/master/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/master/delete')
          return axios.delete(url + `?submitId=${key}`)
                      .then(response => { 
                        if (!response.ok) throw new Error('Network error') })
        },
      })
      this.dailyReportDataSource = new DataSource({ store: this.dailyReportDataStore })
    },
    getReportMap() {
      const url = mapApiUrl('/api/form/master/list/map')
      let params={wellId: this.selectedWell}
      axios
      .get(url, {
        params: params
      }).then((resp) => {
        this.masterReportMap = []
        for (const row of resp.data) {
          this.masterReportMap.push({index: row[0], submitId: row[1]})
        }
        if (this.dailyReportDataStore === null) {
          this.init()  // called here as the map is better be loaded first
        }
      })
    }, 
    setReportNo(rowData) {
      const match = this.masterReportMap.find(x => x.submitId === rowData.submitId)
      return match !== undefined ? match.index : ""
    },
    editingDailyReportStart() {
      this.selectedRow = []
    },
    getStatusText(rowData) {
      const statusTexts = ["DRAFT", "WAITING FOR APPROVAL", "APPROVED", "REJECTED", "APPROVED WITH EDIT"]
      return statusTexts[rowData.approvedStatus - 1]
    },
    initExtraReports() {
      const params = qs.stringify({submitId: this.submitId, lastReportId: this.lastSubmitId})
      axios.post(mapApiUrl("/api/form/master/mud/init"), params)
      axios.post(mapApiUrl("/api/form/master/hse/init"), params)
      axios.post(mapApiUrl("/api/form/master/cost/init"), params)
      axios.post(mapApiUrl("/api/form/master/material-usage/init"), params)
    },
    retrieveReportTable() {
      this.reportData = []
      const url = mapApiUrl('/api/form/master/list-not-approved')
      let params={wellId: this.selectedWell}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportData = response.data
        if (this.reportData === undefined) return
        if (this.reportData.length === 0) return
        // sort data by report date descendingly
        this.reportData.sort((a,b) => { return b.dateReport-a.dateReport }) // Date.parse(b.dateReport) - Date.parse(a.dateReport) })
        this.masterReportMap = []
        this.reportData.forEach((item, index) => {
          item.index = index++
          item.createdAt=item.submittedTime.substr(0,19)
          this.masterReportMap.push({index: item.index, submitId: item.id})
        })
        // last report is at index 1, when it to be used for carry over data
        if (this.reportData.length > 1)
          this.lastSubmitId = this.reportData.at(1).id
          else this.lastSubmitId = 0
      })
    },
    async tabChanged(newTabIndex, prevTabIndex, bvEvent) {
      if ([0,6,8].find(x=> x === prevTabIndex) !== undefined) {
        const confirmed = await confirm('You may have unsaved data. Are you sure you want to switch to another tab? ','Confirmation')
        if (!confirmed) {
          bvEvent.preventDefault()
        }
      } 
    },
    previewReport() {
      window.open('/form/consolidated-daily-drilling-report')
    },
    retrieveComboOptionField() {
      this.comboFieldOption = []
      this.selectedField = null
      this.selectedPad = null
      this.selectedWell = null
      this.getFields({ params: {} }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.fieldId, text: item.fieldName }
          this.comboFieldOption.push(opt)
        })
      })
    },
    retrieveComboOptionPad(fieldId) {
      this.comboPadOption = []
      this.comboWellOption = []
      this.selectedPad = null
      this.selectedWell = null
      this.getPads({ params: { fieldId: fieldId } }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.padId, text: item.padName }
          this.comboPadOption.push(opt)
        })
      })
    },
    retrieveComboOptionWell(padId) {
      this.comboWellOption = []
      this.selectedWell = null
      this.getWells({
        params: { fieldId: this.selectedField, padId: padId },
      }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.wellId, text: item.wellName }
          this.comboWellOption.push(opt)
        })
      })
    },
    fieldChangedEvent(fieldId) {
      this.retrieveComboOptionPad(fieldId)
    },
    padChangedEvent(padId) {
      this.retrieveComboOptionWell(padId)
    },
    wellChangedEvent(wellId) {
      this.selectedWell = wellId
      let selectedWellItem = this.comboWellOption.find((el) => {
        return el.value === wellId
      })
      this.selectedWellName = selectedWellItem.text
      this.selectedRow = []
    },
    showWellSelection() {
      this.showOptionChangeWell = !this.showOptionChangeWell
      if (this.showOptionChangeWell) this.optionChangeWell = 'CLOSE'
      else this.optionChangeWell = 'CHANGE WELL'
    },
    doConfirm() {
      this.confirmSubmit = true
    },
    onSelectionChanged(e) {
      this.selectedRow = e.selectedRowsData
      this.selectedReportNo = this.masterReportMap.find(x => x.submitId === this.selectedRow[0].submitId).index
      window.localStorage.setItem('submitId', this.selectedRow[0].submitId)
      window.localStorage.setItem('reportNo', this.selectedReportNo)

      this.submitId = this.selectedRow[0].submitId
      this.selectedReportDate = new Date(this.selectedRow[0].dateReport).toJSON()
    },
    refreshTable() {
      this.selectedRow = []
      this.$refs.dailyReportGrid.instance.refresh()
    },
    subtractDate(date1, date2) {
      // Clone the dates to avoid mutating the originals
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // Normalize time to midnight
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);

      return (d1-d2) 
    },
    editingStart(e) {
      if ([3,5].findIndex(x => x === e.data.approvedStatus) >= 0) {
        notify({message: 'You can not mmodify an approved report', width: 500}, 'warning', 3000)
        e.cancel = true
      }
    },
    rowInserting(e) {
      e.cancel = this.subtractDate(e.data.dateReport, this.currentWell.spudDate) < 0 
                  ? Promise.reject(new Error("Report date must not be earlier than spud date")) : false
    },
    rowUpdating(e) {
      e.cancel = false
      if (e.newData.dateReport !== undefined) {
        e.cancel = this.subtractDate(e.newData.dateReport, this.currentWell.spudDate) < 0 
                ? Promise.reject(new Error("Report date must not be earlier than spud date")) : false
      }
    },
    rowRemoved(e) {
      const dateString = e.data.data.dateReport
      notify({ message: `Daily report for date ${dateString} has been deleted.`, width: 500 }, 'success', 3000)
    },
    rowInserted(e) {
      const dateString = e.data.data.dateReport
      notify({ message:  `Daily master report for date ${dateString} has been recorded.`, width: 500 }, 'success', 3000)
    },
    rowUpdated(e) {
      const dateString = e.data.data.dateReport
      notify({ message:  `Daily master report for date ${dateString} has been updated.`, width: 500 }, 'success', 3000)
    },
    submitReportAsWaitingApproval() {
      const url = mapApiUrl('/api/form/master/approval')
      const params = { submitId: this.submitId, newApproval: 'WAITING FOR APPROVAL' }
      axios.post(url, qs.stringify(params))
        .then((response) => {
          this.refreshTable()
          notify({ message: 'This daily drilling report has been submitted.', width: 500 }, 'success', 3000)
      }).catch((err) => {
        notify({ message: err.response.data.error, width: 300 }, 'error', 1000)
        this.refreshTable()
      }) 
    },
    retrieveWellboreList() {
      this.getComboWellbore({ params: { well_id: this.selectedWell } }).then(
        (resp) => {
          this.wellboreList = resp.data.data
        }
      )
    },
    retrieveRigOpsList() {
      this.getComboRigOps({ params: { well_id: this.selectedWell } }).then(
        (resp) => {
          this.rigOpsList = resp.data.data
        }
      )
    },
  },
}
</script>
